import React,{Component} from "react";
import { Field, reduxForm } from "redux-form";
import { Form, FormGroup, Button, Label, Row, Col, CardBody, UncontrolledTooltip, CardFooter } from "reactstrap";
import {
    renderField,
    number,
    renderCheckbox,
    required,
    renderTextArea,
    renderPass,
    renderPassTextArea, json,
} from "../../../utils/formValidations.js";
import { connect } from "react-redux";
import { getServers, updateServer, createServer} from "../../../actions/actionServer";
import { getServerPools} from "../../../actions/actionServerPool";
import { NotificationManager } from "react-notifications";
import { withRouter } from "react-router-dom";
import Proptypes from "prop-types";
import SelectInput from "../../../components/SelectInput";
import {getZones} from "../../../actions/actionZones";

class AgentFormTemplate extends Component  {
    constructor(props){
        super(props);
        this.state  = {
            currentServer: null,
            pool: new URLSearchParams(this.props.location.search).get('pool') || null,
            disableMaxPerServer: false,
        };
        this.submitServer= this.submitServer.bind(this);
        this.cancelButton = this.cancelButton.bind(this);
        this.handleUpdateSuccess = this.handleUpdateSuccess.bind(this);
        this.connection_type = this.connection_type.bind(this);
    }

    connection_type(type) {
        if (type === 'KasmVNC') {
            this.setState({ disableMaxPerServer: true })
            this.props.change('max_simultaneous_sessions', 1);
        }
        if (type === 'RDP') {
            this.setState({ disableMaxPerServer: false })
        }
    }

    handleUpdateSuccess(){
        const {updateErrorServerMessage} = this.props;
        if(updateErrorServerMessage){
            NotificationManager.error(updateErrorServerMessage,"Update Server", 3000);
        }
        else {
            NotificationManager.success("Server Update", "Successfully Updated Server");
            if(this.state.pool) {
                this.props.history.push("/update_server_pool/" + this.state.pool);
            } else {
                this.props.history.push("/servers");
            }
        }
    }

    handleUpdateError(){
        const {updateServerError} = this.props;
        if(updateServerError){
            NotificationManager.error(updateServerError,"Update Server", 3000);
        }
    }

    handleCreateSuccess(){
        const {createErrorServerMessage} = this.props;
        if(createErrorServerMessage){
            NotificationManager.error(createErrorServerMessage,"Create Server", 3000);
        }
        else {
            NotificationManager.success("Server Create", "Successfully Created Server");
            if(this.state.pool) {
                this.props.history.push("/update_server_pool/" + this.state.pool);
            } else {
                this.props.history.push("/servers");
            }
        }
    }

    handleCreateError(){
        const {createServerError} = this.props;
        if(createServerError){
            NotificationManager.error(createServerError,"Create Server", 3000);
        }
    }


    submitServer(userData){
        userData.server_type = "Desktop"
        if (this.props.fromUpdate){
            userData.server_id = this.state.currentServer.server_id;
            this.props.updateServer(userData).
             then(() => this.handleUpdateSuccess()).
             catch(() => this.handleUpdateError());
        }
        else{
            this.props.createServer(userData).
            then(() => this.handleCreateSuccess()).
            catch(() => this.handleCreateError());
        }

    }

    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.servers.length > 0 && this.props.servers !== nextProps.servers && this.props.getServersLoading && this.props.fromUpdate){
            let currentServer= nextProps.servers.find(servers => servers.server_id === this.props.serverId);
            //let currentServers =  nextProps.servers.find(servers => servers.server_id === currentImage.server_id);
            this.setState({currentServer: currentServer});
            this.props.initialize({
                server_type: currentServer.server_type,
                connection_type: currentServer.connection_type,
                connection_info: JSON.stringify(currentServer.connection_info, null, 2),
                max_simultaneous_sessions: currentServer.max_simultaneous_sessions,
                hostname: currentServer.hostname,
                friendly_name: currentServer.friendly_name,
                zone_id: currentServer.zone_id,
                server_id: currentServer.server_id,
                enabled: currentServer.enabled,
                server_pool_id: currentServer.server_pool_id,
                connection_username: currentServer.connection_username,
                connection_password: currentServer.connection_password,
                connection_port: currentServer.connection_port,
            });
            if (currentServer.connection_type === 'KasmVNC') {
                this.setState({disableMaxPerServer: true});
            }
        }
    }

    cancelButton(){
        this.props.history.push("/servers");
    }

    async componentDidMount(){
        this.props.getZones()
        if (this.props.fromUpdate){
            this.props.getServers();
        }
        await this.props.getServerPools()
        this.props.change('server_pool_id', this.state.pool);

    }

    render(){
        const {handleSubmit, agentFormValues, zones, fromUpdate, server_pools} = this.props;
        let prune_images_options = [
            {label: "Off", value: "Off"},
            {label: "Normal", value: "Normal"},
            {label: "Aggressive", value: "Aggressive"}
        ];

        let optionsConnectionType = [{label: "KasmVNC", value: "KasmVNC"}, {label: "RDP", value: "RDP"}];
        let optionsZones = [];
        zones.map(opt => {
            optionsZones.push({label: opt.zone_name, value: opt.zone_id, zone_name: opt.zone_name });
        });
        optionsZones.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);

        let optionsServerPools = [];
        server_pools.map(opt => {
            if (opt.server_pool_type === 'Server Pool') {
                optionsServerPools.push({label: opt.server_pool_name, value: opt.server_pool_id});
            }
        });
        optionsServerPools.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);
        //const checked = true;
        return (
            <React.Fragment>

                { ((agentFormValues && agentFormValues.server_type === "Desktop") || ! this.props.fromUpdate ) ?
                <Form onSubmit={handleSubmit(this.submitServer)}>
                    <CardBody>
                        <FormGroup>
                            <Row>
                                <Col>
                                    <Label htmlFor="enabled" className="requiredasterisk">Enabled</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Field type="checkbox"
                                        name="enabled"
                                        id="enabled"
                                        component={renderCheckbox}
                                        //check={checked}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col>
                                    <Label htmlFor="friendly_name" className="">Friendly Name</Label>

                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Field type="text"
                                        name="friendly_name"
                                        id="friendly_name"
                                        component={renderField}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col>
                                    <Label htmlFor="hostname" className="requiredasterisk">IP/Hostname</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Field type="text"
                                        name="hostname"
                                        id="hostname"
                                        component={renderField}
                                        validate={required}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col>
                                    <Label htmlFor="connection_type" className="requiredasterisk">Connection Type</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Field name="connection_type"
                                           selectedValue={agentFormValues && agentFormValues.connection_type ? agentFormValues.connection_type: ""}
                                           options={optionsConnectionType}
                                           onOptionChange={this.connection_type}
                                           validate={required}
                                           isUpdateForm={this.props.fromUpdate}
                                           component={SelectInput}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col>
                                    <Label htmlFor="connection_port" className="requiredasterisk">Connection Port</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Field type="number"
                                        name="connection_port"
                                        id="connection_port"
                                        component={renderField}
                                        validate={number}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col>
                                    <Label htmlFor="connection_username" className={this.props.agentFormValues && this.props.agentFormValues.connection_type === 'KasmVNC' ? 'requiredasterisk' : ''}>Connection Username</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Field type="text"
                                        name="connection_username"
                                        id="connection_username"
                                        component={renderField}
                                        validate={this.props.agentFormValues && this.props.agentFormValues.connection_type === 'KasmVNC' ? required : null}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col>
                                    <Label htmlFor="connection_password" className={this.props.agentFormValues && this.props.agentFormValues.connection_type === 'KasmVNC' ? 'requiredasterisk' : ''}>Connection Password</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Field  type="connection_password"
                                            name="connection_password"
                                            id="connection_password"
                                            component={renderPass}
                                            validate={this.props.agentFormValues && this.props.agentFormValues.connection_type === 'KasmVNC' ? required : null}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col>
                                    <Label htmlFor="connection_info" className="">Connection Info (JSON)</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Field type="textarea"
                                        name="connection_info"
                                        id="connection_info"
                                        component={renderTextArea}
                                        validate={json}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col>
                                    <Label htmlFor="max_simultaneous_sessions" className="requiredasterisk">Max Simultaneous Sessions</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Field type="number"
                                        name="max_simultaneous_sessions"
                                        id="max_simultaneous_sessions"
                                        disabled={this.state.disableMaxPerServer}
                                        component={renderField}
                                        validate={number}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                         <FormGroup>
                            <Row>
                                <Col>
                                    <Label htmlFor="server_id" className="requiredasterisk">Deployment Zone</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Field name="zone_id"
                                        selectedValue={agentFormValues && agentFormValues.zone_id ? agentFormValues.zone_id : ""}
                                        options={optionsZones}
                                        isUpdateForm={this.props.fromUpdate}
                                        validate={required}
                                        component={SelectInput}  />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col>
                                    <Label htmlFor="server_pool_id">Pool</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Field name="server_pool_id"
                                        selectedValue={agentFormValues && agentFormValues.server_pool_id ? agentFormValues.server_pool_id : ""}
                                        options={optionsServerPools}
                                        isUpdateForm={this.props.fromUpdate}
                                        clearable={true}
                                        component={SelectInput}  />
                                </Col>
                            </Row>
                        </FormGroup>
                    </CardBody>
                    <CardFooter>
                        <FormGroup className="form-actions">
                            <Button type="cancel" size="sm"
                            className="cancel-button"
                            color="basic" onClick={() => this.cancelButton()}> Cancel</Button>
                            <Button type="submit" size="sm"
                            className="submit-button"
                            color="primary">Submit</Button>
                        </FormGroup>
                    </CardFooter>
                </Form>
            : ""}
            </React.Fragment>

        )
    }
}

AgentFormTemplate.propTypes = {
    updateServer: Proptypes.func.isRequired,
    createServer: Proptypes.func.isRequired,
    getServers: Proptypes.func.isRequired,
    history: Proptypes.object.isRequired,
    updateServerError: Proptypes.func,
    updateErrorServerMessage: Proptypes.string,
    fromUpdate: Proptypes.bool,
    servers: Proptypes.array,
    getServeraLoading: Proptypes.bool,
    initialize: Proptypes.func,
    agentFormValues: Proptypes.object,
    handleSubmit: Proptypes.func,
    serverId: Proptypes.string,
    getZones: Proptypes.func,
    getServerPools: Proptypes.func,
    zones: Proptypes.array,
    server_pools: Proptypes.array,
};

let AgentFormWithRouter = withRouter(AgentFormTemplate);

let ServerForm =  connect(state =>
    ({
        servers: state.servers.servers || [],
        agentFormValues: state.form && state.form.agentForm && state.form.agentForm.values ? state.form.agentForm.values : null,
        updateErrorServerMessage: state.servers.updateErrorServerMessage || null,
        updateServerError: state.servers.updateServerError || null,
        getServersLoading: state.servers.getServersLoading || false,
        zones: state.zones.zones || [],
        server_pools: state.server_pools.server_pools || [],
    }),
dispatch => 
    ({
        updateServer: (data) => dispatch(updateServer(data)),
        createServer: (data) => dispatch(createServer(data)),
        getServers: () => dispatch(getServers()),
        getZones: () => dispatch(getZones()),
        getServerPools: () => dispatch(getServerPools()),
    }))(AgentFormWithRouter);

export default reduxForm({
    form: "agentForm",
})(ServerForm);